import { FunctionComponent } from "react";
import styles from "./SwitchInfo.web.css";
import { SwitchInfoProps } from "./SwitchInfo.types";

export const SwitchInfo: FunctionComponent<SwitchInfoProps> = ({ hint, learnMoreUrl, learnMoreLabel }) => {
  if (!learnMoreUrl) return <>{hint}</>;
  return (
    <>
      {hint}{" "}
      <a
        href={learnMoreUrl}
        target="_blank"
        rel="noopener noreferrer"
        className={styles.learnMoreLink}
        onClick={(e) => e.stopPropagation()}
      >
        {learnMoreLabel}
      </a>
    </>
  );
};
